/* tslint:disable */
/* eslint-disable */
/**
 * pinnacle-backend API spec
 * Backend Service for Pinnacle Underwriting | [swagger.json](pinnacle/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ReceiptSourceBrokerResponseDto
 */
export interface ReceiptSourceBrokerResponseDto {
    /**
     * Source broker ID
     * @type {string}
     * @memberof ReceiptSourceBrokerResponseDto
     */
    brokerId: string;
    /**
     * Source broker name
     * @type {string}
     * @memberof ReceiptSourceBrokerResponseDto
     */
    name: string;
}

/**
 * Check if a given object implements the ReceiptSourceBrokerResponseDto interface.
 */
export function instanceOfReceiptSourceBrokerResponseDto(value: object): value is ReceiptSourceBrokerResponseDto {
    if (!('brokerId' in value) || value['brokerId'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    return true;
}

export function ReceiptSourceBrokerResponseDtoFromJSON(json: any): ReceiptSourceBrokerResponseDto {
    return ReceiptSourceBrokerResponseDtoFromJSONTyped(json, false);
}

export function ReceiptSourceBrokerResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ReceiptSourceBrokerResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'brokerId': json['brokerId'],
        'name': json['name'],
    };
}

export function ReceiptSourceBrokerResponseDtoToJSON(json: any): ReceiptSourceBrokerResponseDto {
    return ReceiptSourceBrokerResponseDtoToJSONTyped(json, false);
}

export function ReceiptSourceBrokerResponseDtoToJSONTyped(value?: ReceiptSourceBrokerResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'brokerId': value['brokerId'],
        'name': value['name'],
    };
}

